import { gql } from '@apollo/client/core'

export const FILE_UPLOAD_FRAGMENT = gql`
  fragment FileUpload on FetchUploadOutput {
    upload {
      url
      fields {
        key
        value
      }
    }
  }
`
